import { Component } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ProductUnregulatedService } from '../../../product-unregulated.service';
import {
  ICustomizedFormat,
  IHierarchyFormat,
  PRODUCTS_UNREGULATED_TTL_ES
} from '../../../product-unregulated.interface';
import { CreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.template';
import { ICreateTemplate } from 'src/app/@amiga-pyme/crud/templates/create/create.interface';
import { MessageService } from 'primeng/api';
@Component({
  selector: 'pg-product-unregulated-create',
  templateUrl: './product-unregulated-create.component.html',
  providers: [MessageService]
})
export class ProductUnregulatedCreateComponent
  extends CreateTemplate
  implements ICreateTemplate
{
  disabled: boolean;
  length0fObject: any;
  constructor(
    private fb: FormBuilder,
    private baseService: ProductUnregulatedService,
    private messageService: MessageService
  ) {
    super(PRODUCTS_UNREGULATED_TTL_ES, baseService);
  }

  readyToCreate = false;

  hasPurchaseFormat = false;
  hasMinSaleFormat = false;

  clonedHierarchyFormat: { [s: string]: IHierarchyFormat } = {};
  clonedCustomizedFormat: { [s: string]: ICustomizedFormat } = {};
  hierarchyFormats = [];
  statuses = [];
  nameList = [];
  hierarchyFormatLength = 0;
  customizedFormatLength = 0;
  formatObj = {};
  ngOnInit() {
    this.disabled = false;
    this.fg = this.fb.group({
      code: ['', [Validators.required, Validators.min(1)]],
      name: [
        '',
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(255)
        ]
      ],
      barCode: ['', [Validators.minLength(5), Validators.maxLength(32)]]
    });
    this.hierarchyFormats = [
      {
        id: 1,
        nombre: '',
        subFormat: '',
        cantidad: 1,
        isFormatSale: false,
        isFormatSaleMin: false,
        isFormatPurchase: true
      }
    ];
  }

  parseData() {
    const { code, name, barCode } = this.fg.value;
    const data = {
      code,
      name,
      format: this.formatObj
    };

    if (barCode !== '') {
      data['barCode'] = barCode;
    }

    return data;
  }

  onHierarchyRowEdit(product: IHierarchyFormat) {
    this.clonedHierarchyFormat[product.id] = { ...product };
  }

  onHierarchyRowEditSave(product: IHierarchyFormat) {
    if (this.hierarchyFormats[product.id]) {
      this.hierarchyFormats[product.id].nombre = product.subFormat;
    }
    delete this.clonedHierarchyFormat[product.id];
    this.checkEssentialFormatsExistence();
  }

  onHierarchyRowEditCancel(product: IHierarchyFormat, index: number) {
    this.hierarchyFormats[index] = this.clonedHierarchyFormat[product.id];
    delete this.clonedHierarchyFormat[product.id];
    this.checkEssentialFormatsExistence();
  }

  hierarchyAddRow(ri: number) {
    this.disabled = true;
    this.hierarchyFormats.push({
      id: ri + 2,
      nombre: this.hierarchyFormats[ri].subFormat,
      subFormat: '',
      cantidad: 1,
      isFormatSale: false,
      isFormatSaleMin: false,
      isFormatPurchase: false
    });
    this.hierarchyFormatLength = this.hierarchyFormats.length - 1;
  }
  hierarchyDeleteRow() {
    if (this.hierarchyFormats[this.hierarchyFormatLength - 1].id == 1) {
      this.disabled = false;
    }
    this.hierarchyFormats.pop();
    this.hierarchyFormatLength = this.hierarchyFormats.length - 1;

    this.checkEssentialFormatsExistence();
  }

  cambiarCheck(ri) {
    for (let index = 0; index < this.hierarchyFormats.length; index++) {
      if (index !== ri) {
        this.hierarchyFormats[index].isFormatSaleMin = false;
      }
    }
    this.hierarchyFormats[ri].subFormat = undefined;
  }
  setNameList() {
    this.statuses = [];
    for (let index = 0; index < this.hierarchyFormats.length; index++) {
      this.statuses.push({
        label: this.hierarchyFormats[index].nombre,
        value: this.hierarchyFormats[index].nombre
      });
    }
    this.statuses.push({ label: 'Vacío', value: '' });
  }

  prepareJSON() {
    const myObj = {};
    for (const key in this.hierarchyFormats) {
      const element = this.hierarchyFormats[key];
      if (
        element.nombre !== '' &&
        element.subFormat !== '' &&
        element.cantidad !== 0
      ) {
        myObj[element.nombre] = {
          subFormat: element.subFormat === null ? undefined : element.subFormat,
          quantitySubFormat: element.cantidad,
          isFormatSale: element.isFormatSale,
          isFormatSaleMin: element.isFormatSaleMin,
          isFormatPurchase: element.isFormatPurchase
        };
      }
    }
    this.length0fObject = 0;
    this.formatObj = myObj;
    for (const key in this.formatObj) {
      this.length0fObject++;
    }

    return true;
  }
  setReadyToCreate() {
    return (this.readyToCreate =
      this.fg.value.code &&
      this.fg.value.name &&
      this.hierarchyFormats[0].nombre !== '' &&
      this.hierarchyFormats[0].subFormat !== '');
  }

  checkEssentialFormatsExistence() {
    this.hasPurchaseFormat = false;
    this.hasMinSaleFormat = false;

    for (const format of this.hierarchyFormats) {
      if (
        Object.prototype.hasOwnProperty.call(format, 'isFormatSaleMin') &&
        format['isFormatSaleMin'] === true
      ) {
        this.hasMinSaleFormat = true;
      }

      if (
        Object.prototype.hasOwnProperty.call(format, 'isFormatPurchase') &&
        format['isFormatPurchase'] === true
      ) {
        this.hasPurchaseFormat = true;
      }
    }
  }

  onSubmit() {
    if (this.setReadyToCreate()) {
      if (this.prepareJSON()) {
        if (this.readyToCreate) {
          this.createItem$(this.parseData());
        }
      } else {
        this.messageService.add({
          severity: 'warn',
          summary: 'Campos Incompletos',
          detail: 'El Formato de Venta está incompleto'
        });
      }
    }
  }
}
